import React from "react"

import Badge from "../../../components/ui/badge/badge"

/**
 * Status badge for a queued enquiry's parse state.
 *
 * Three states:
 *   - hasParsedAt && parsed   → "Parsed"        (POSITIVE)
 *   - hasParsedAt && !parsed  → "Parse failed"  (NEGATIVE)
 *   - !hasParsedAt            → "Not parsed"    (default)
 *
 * Used by both the email-queue row (state read from Firestore) and the
 * website-queue row (state read from the parent tab's transient cache).
 */
export function ParseStatusBadge({ hasParsedAt, parsed }) {
	if (!hasParsedAt) return <Badge label="Not parsed" />
	if (parsed) return <Badge type="POSITIVE" label="Parsed" />
	return <Badge type="NEGATIVE" label="Parse failed" />
}

/**
 * "X / Y" cell — count of populated fields against the total expected.
 * Counts a field as "filled" when its value is not null/undefined and not
 * an empty string or empty array. Uses the field-list snapshot supplied by
 * the caller so the count stays honest against whatever prompt produced the
 * result (rather than against the live Development-tab settings).
 */
export function FieldsCompletedCell({ parsed, fields }) {
	if (!parsed || !Array.isArray(fields) || fields.length === 0) {
		return <small className="no-value">—</small>
	}

	let filled = 0
	for (const field of fields) {
		const value = parsed[field.key]
		if (value === null || value === undefined) continue
		if (Array.isArray(value) && value.length === 0) continue
		if (typeof value === "string" && value.trim() === "") continue
		filled += 1
	}

	return (
		<span className="queue-row-fields-count">
			<strong>{filled}</strong>
			<span className="queue-row-secondary"> / {fields.length}</span>
		</span>
	)
}
